import React from "react";
import { inject, observer } from "mobx-react";
import { SearchResultsList } from "../components/search/SearchResultsList";
import { Grid, Row, Col, Alert, Button, Glyphicon } from "react-bootstrap";
import { withRouter } from "../utils/Utils";

@inject("searchStore")
@observer
class SearchResultsPages extends React.Component {
  componentDidMount() {
    const { searchStore } = this.props;
    this.updateStoreWithQueryParams();
    searchStore.fetchSearchMetadata().then(() => {
      searchStore.fetchSearchResults();
    });
  }

  componentDidUpdate(prevProps) {
    const { location, searchStore } = this.props;
    if (location.search !== prevProps.location.search) {
      this.updateStoreWithQueryParams();
      searchStore.fetchSearchResults();
    }
  }

  componentWillUnmount() {
    const { setUserProfileChanged } = this.props.searchStore;
    setUserProfileChanged(false);
  }

  updateStoreWithQueryParams = () => {
    const { location, searchStore } = this.props;
    const params = new URLSearchParams(location.search);
    const searchQuery = params.get("search");
    searchStore.setSearchQuery(searchQuery ? decodeURI(searchQuery) : "");
    searchStore.setLastSearchQuery(searchQuery ? decodeURI(searchQuery) : "");
    const selectedTypes = params.get("types");
    searchStore.setSelectedTypes(selectedTypes ? selectedTypes.split(",") : []);
    const selectedFramework = params.get("framework");
    switch (selectedFramework) {
      case "micro":
        searchStore.setSelectedFramework({
          code: searchStore.getMicroFrameworks.map((fw) => fw.code).join(", "),
          description: "Micro Frameworks",
          frameworkId: "micro",
          maintenanceAgencyId: "",
          name: "Micro Frameworks",
          tid: "micro",
          type: "FrameworkGroup",
          groupTids: searchStore.getMicroFrameworks.map((fw) => fw.tid),
        });
        break;
      case "macro":
        searchStore.setSelectedFramework({
          code: searchStore.getMacroFrameworks.map((fw) => fw.code).join(", "),
          description: "Macro Frameworks non-reference",
          frameworkId: "macro",
          maintenanceAgencyId: "",
          name: "Macro Frameworks non-reference",
          tid: "macro",
          type: "FrameworkGroup",
          groupTids: searchStore.getMacroFrameworks.map((fw) => fw.tid),
        });
        break;
      case "eba":
        searchStore.setSelectedFramework({
          code: searchStore.getEbaFrameworks.map((fw) => fw.code).join(", "),
          description: "EBA ITS non-referece",
          frameworkId: "eba",
          maintenanceAgencyId: "",
          name: "EBA ITS non-reference",
          tid: "eba",
          type: "FrameworkGroup",
          groupTids: searchStore.getEbaFrameworks.map((fw) => fw.tid),
        });
        break;
      case "all":
        searchStore.setSelectedFramework(undefined);
        break;
      default:
        const target = searchStore.getFrameworks.find(
          (framework) => framework.frameworkId === selectedFramework
        );
        if (target) {
          searchStore.setSelectedFramework(target);
        } else {
          searchStore.setSelectedFramework(undefined);
        }
        break;
    }
    /* const selectedCubeTypes = params.get("cubeTypes"); */
    /* if (selectedCubeTypes) {
      if (selectedCubeTypes === "all") {
        searchStore.setSelectedCubeTypes([]);
      } else {
        searchStore.setSelectedCubeTypes(selectedCubeTypes.split(","));
      }
    } */
    const selectedDate = params.get("validityDate");
    if (selectedDate)
      searchStore.setSelectedDate(new Date(selectedDate).toString());
  };

  render() {
    const {
      getSearchResults,
      filtersVisible,
      getMetadata,
      getSearchMetadata,
      getLastSearchQuery,
      getUserProfileChanged,
    } = this.props.searchStore;

    return (
      <div
        className={`container search-results-page ${
          filtersVisible ? "showFilters" : ""
        }`}
      >
        {getUserProfileChanged === true ? (
          <Alert bsStyle="warning" className="warning-user-profile">
            <div>
              <Glyphicon glyph="warning-sign" />
              Your application profile has changed. Reload the page to reflect
              possible changes.
            </div>
            <Button onClick={() => window.location.reload()}>Reload</Button>
          </Alert>
        ) : null}
        <Grid>
          <Row>
            <Col xs={12}>
              <h4>{`Search results for "${getLastSearchQuery}"`}</h4>
              {getMetadata &&
              getSearchMetadata &&
              getSearchResults &&
              Object.keys(getMetadata).length &&
              Object.keys(getSearchMetadata).length &&
              Object.keys(getSearchResults).length ? (
                getSearchResults.results && getSearchResults.results.length ? (
                  <SearchResultsList />
                ) : (
                  <div>Nothing found</div>
                )
              ) : (
                <div>Searching...</div>
              )}
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const SearchResultsPage = withRouter(SearchResultsPages);
export { SearchResultsPage };
